<template>
  <span class="h-tag" :class="colorClass"><slot></slot></span>
</template>

<script>
/**
 * 轻量 Tag 组件。
 * 本版 HeyUI 仅内置 TagInput，无独立 Tag 组件；此处复用主题中的 .h-tag / .h-tag-{color}
 * 样式类，提供与 HeyUI Tag 一致的 color 取值（gray/green/red/blue/primary/yellow）。
 * 全局注册后，各页面 <Tag color="..."> 直接生效。
 */
export default {
  name: 'Tag',
  props: {
    color: { type: String, default: '' }
  },
  computed: {
    colorClass() {
      return this.color ? 'h-tag-' + this.color : '';
    }
  }
};
</script>
</content>
</invoke>
